import { AnomaliesPage } from 'features/anomalies';

export const TechOperatorAnomaliesPage: React.FC = () => <AnomaliesPage />;
